module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/dryShampoo@2x_631827.png";